import {
  DeploymentEnvironment,
  getFeatureFlagValue as commonGetFeatureFlagValue,
} from '@magicbrief/common';
import type { Feature, FeatureFlags } from '@magicbrief/common';

export function getFeatureFlagValue<T extends Feature>(
  key: T,
  override?: FeatureFlags[T]
): FeatureFlags[T] {
  return commonGetFeatureFlagValue(
    key,
    import.meta.env.VITE_DEPLOYMENT as DeploymentEnvironment,
    override
  );
}
